// src/services/userService.ts
import { AxiosResponse } from 'axios';
import apiClient from './apiClient';

/**
 * 現在ログイン中のユーザー情報を取得する API
 * GET: /me/
 */
export const getCurrentUser = async (): Promise<AxiosResponse> => {
  return apiClient.get('/users/me/');
};

/**
 * ユーザー情報の一部更新（プロフィール、連絡先、自動応答テンプレートなど）
 * PATCH: /me/
 * @param data 更新対象フィールド群（例: { username, email, auto_response_prompt_free, auto_response_prompt_premium }）
 */
export const updateCurrentUser = async (
  data: Record<string, any>
): Promise<AxiosResponse> => {
  return apiClient.patch('/users/me/', data);
};

/**
 * パスワード変更 API
 * POST: /me/change-password/
 * @param data { old_password: string, new_password: string }
 */
export const changePassword = async (data: {
  old_password: string;
  new_password: string;
}): Promise<AxiosResponse> => {
  return apiClient.post('/users/me/change-password/', data);
};

/**
 * アカウント削除 API
 * DELETE: /users/me/delete/
 */
export const deleteAccount = (): Promise<AxiosResponse<void>> => {
  return apiClient.delete('/users/me/delete/');
};
